import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { CompanyId } from "~/context/Company/domain/CompanyId";
import { SubscriptionRepository } from "../domain/SubscriptionRepository";

export async function getDaysSubscriptionEnds(
  repository: SubscriptionRepository,
  companyId: string,
): Promise<VectiResult> {
  const myCompanyId = new CompanyId(companyId);
  try {
    const result = await repository.getDaysSubscriptionEnds(myCompanyId.toString())
    console.log("getDaysSubscriptionEnds", JSON.stringify(result));
    return new VectiResult(true, result);
  } catch (error) {
    console.log("error getDaysSubscriptionEnds:" + error);
    return new VectiResult(false, "Error");
  }
}
